import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import { Box } from "@mui/system";
import * as React from "react";
// import UploadConfig from "./UploadConfig";
import TestConfig from "./TestConfig";
import ReportDWS from "./Report";
import ConfigList from "./ConfigList";

function DwsConfig() {
    const [value, setValue] = React.useState("2");
    const handleChange = (_event, newValue) => {
        setValue(newValue);
    };
    return (
        <>
            <TabContext value={value}>
                <Box sx={{ backgroundColor: "#fff", boxShadow: 1 }}>
                    <TabList
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        sx={{
                            "& .MuiTab-root": {
                                px: 7,
                                py: 2,
                            },
                        }}
                    >
                        {/* <Tab
                            iconPosition="top"
                            label="Upload Config"
                            value="1"
                        /> */}
                        <Tab
                            iconPosition="top"
                            label="Config List"
                            value="2"
                        />
                        <Tab
                            label="Test Config"
                            value="3"
                            iconPosition="top"
                        />
                        <Tab
                            label="Report"
                            value="4"
                            iconPosition="top"
                        />
                    </TabList>
                </Box>
                {/* <TabPanel value="1" sx={{ px: 0 }}>
                    <UploadConfig />
                </TabPanel> */}
                <TabPanel value="2" sx={{ px: 0 }}>
                    <ConfigList />
                </TabPanel>
                <TabPanel value="3" sx={{ px: 0 }}>
                    <TestConfig />
                </TabPanel>
                <TabPanel value="4" sx={{ px: 0 }}>
                    <ReportDWS />
                </TabPanel>
            </TabContext>
        </>
    );
}

export default DwsConfig;
